import { Backdrop, Popper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import style from "./FilterModal.module.css";
import CustomSelectAccordion from "../Select/CustomSelectAccordion";
import { useCallback } from "react";

const Boxstyle = {
  background: "#FFFFFF",
  width: "20%",
  minHeight: "15%",
  maxHeight: "78%",
  borderRadius: "4px",
  zIndex: 2,
  color: "black",
  // position: "absolute",
  // top: "100rem",
  // left: "0",
  // right: "3rem",
  overflow: "auto",
  overscrollBehavior: "contain",
};

const blockOption = [{ label: "Select Block", values: [""] }];

const FilterModal = ({
  blockDetails = [],
  dropdownData = [],
  selectedFilters = null,
  setSelectedFilters = () => {},
  filters = null,
  setFilters = () => {},
  closeFilter = () => {},
  isFilterPopOverActive,
  id,
  anchorEl,
}) => {
  const [isLocationClicked, setIsLocationClicked] = useState(false);
  const [isBlockCliked, setIsBlockClikced] = useState(false);
  console.log(anchorEl, "anchorEl");
  const locationHandler = () => {
    setIsLocationClicked((prev) => !prev);
  };
  const blockHandler = () => {
    setIsBlockClikced((prev) => !prev);
  };

  const handleSelect = useCallback(
    (value, key) => {
      setSelectedFilters((prev) => {
        let newValue = value;
        if (key === "state") prev.city = "";
        return {
          ...prev,
          [key]: newValue,
        };
      });
    },
    [blockDetails]
  );

  const onReset = (type) => {
    let resetData = {
      state: "",
      city: "",
      blocks: type === "location" ? filters?.blocks : [],
      isApplied:
        type === "location" && filters?.blocks?.length
          ? filters?.isApplied
          : false,
    };
    setSelectedFilters({
      ...resetData,
      blocks: resetData?.blocks?.map((obj) => obj?.block_name),
    });
    setFilters({ ...resetData });
  };

  const onApply = (type) => {
    let dataToApply = {
      ...selectedFilters,
      isApplied: true,
      blocks:
        type === "all"
          ? blockDetails?.filter((obj) =>
              selectedFilters?.blocks?.includes(obj?.block_name)
            )
          : [],
    };
    setSelectedFilters({
      ...dataToApply,
      blocks: type === "all" ? selectedFilters?.blocks : [],
    });
    setFilters({ ...dataToApply });
    closeFilter();
  };

  //block_name
  useEffect(() => {
    const blockNames = blockDetails.map((item) => item.block_name);
    blockOption[0].values = [...blockNames];
  }, [blockDetails]);

  return (
    <Backdrop
      sx={{
        color: "#fff",
        overscrollBehavior: "contain",
        zIndex: 1,
      }}
      open={isFilterPopOverActive}
    >
      <Popper
        id={id}
        open={isFilterPopOverActive}
        anchorEl={anchorEl}
        placement={"bottom-start"}
        sx={Boxstyle}
      >
        <div className={style["main_container"]}>
          <p className={style["location"]} onClick={locationHandler}>
            Filter by Location
          </p>
          {isLocationClicked ? (
            <>
              <div style={{ marginBottom: "1rem" }}>
                <CustomSelectAccordion
                  value={selectedFilters?.state}
                  options={[
                    {
                      label: "Select State",
                      values: [...dropdownData?.map((obj) => obj?.state)],
                    },
                  ]}
                  onSelect={(value) => handleSelect(value, "state")}
                />
              </div>
              <CustomSelectAccordion
                value={selectedFilters?.city}
                options={[
                  {
                    label: "Select City",
                    values: [
                      ...(dropdownData?.find(
                        (obj) =>
                          obj?.state?.toLowerCase() ==
                          selectedFilters?.state?.toLowerCase()
                      )?.city || []),
                    ],
                  },
                ]}
                onSelect={(value) => handleSelect(value, "city")}
              />
              {!isBlockCliked && (
                <div className={style["btn_container"]}>
                  <button
                    className={`${style["reset_btn"]} ${
                      selectedFilters?.city ? style["active"] : ""
                    }`}
                    onClick={() => onReset("location")}
                  >
                    Reset
                  </button>
                  <button
                    className={`${style["apply_btn"]} ${
                      selectedFilters?.city ? style["active"] : ""
                    }`}
                    onClick={() => onApply("location")}
                  >
                    Apply
                  </button>
                </div>
              )}
            </>
          ) : null}
          <p className={style["block"]} onClick={blockHandler}>
            Filter by Block
          </p>
          {isBlockCliked ? (
            <>
              <CustomSelectAccordion
                checkBox
                // value={selectedFilters?.blocks?.map((block) => block?.block_name)}
                value={selectedFilters?.blocks}
                options={blockOption}
                onSelect={(value) => handleSelect(value, "blocks")}
              />
              <div className={style["btn_container"]}>
                <button
                  className={`${style["reset_btn"]} ${
                    selectedFilters?.city || selectedFilters?.blocks?.length
                      ? style["active"]
                      : ""
                  }`}
                  onClick={() => onReset("all")}
                >
                  Reset
                </button>
                <button
                  className={`${style["apply_btn"]} ${
                    selectedFilters?.city || selectedFilters?.blocks?.length
                      ? style["active"]
                      : ""
                  }`}
                  onClick={() => onApply("all")}
                >
                  Apply
                </button>
              </div>
            </>
          ) : null}
        </div>
      </Popper>
    </Backdrop>
  );
};

export default FilterModal;
